export enum LayerEnum {
    background = 0,
    ground = 1,
    ceiling = 2,
    scroll = 3
}
